export default context => {
    const input = context.querySelector('input');

    input.addEventListener('focus', () => context.classList.add('input--focused'));
    input.addEventListener('blur', () => context.classList.remove('input--focused'));

    function reset() {
        input.value = '';
        context.classList.remove('has-remark');
        context.removeAttribute('data-state');
    }

    function focus() {
        input.focus();
    }

    function blur() {
        input.blur();
    }

    function hasValue() {
        return input.value.trim().length > 0;
    }

    function getValue() {
        return input.value;
    }

    function setValue(value) {
        input.value = value;
    }

    return {
        reset,
        focus,
        blur,
        hasValue,
        getValue,
        setValue
    };
};
